import React from 'react';
import { FONT, TEXT, TEXT3, WHITE } from '../../../shared';

// Email_Campaign — Inbox-style email preview chrome
// Reference: Vella_Preview_Mockup_Spec.md (Email Campaign)
// Gmail/Outlook-clean look · header (From/To/Subject/Date) · email body area
export default function EmailPreviewChrome({
  assetUrl,
  subject = "Welcome to Your Brand — start saving today",
  fromName = "Your Brand",
  fromEmail = "hello@yourbrand.com",
  toEmail = "you@example.com",
  date,
  preheader,
  body = "",
  ctaText = "Shop now",
  ctaUrl = "https://yourbrand.com",
  ctaColor = "#0EA5E9",
}) {
  const sentDate = date || new Date().toLocaleDateString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  const initial = (fromName || "B").charAt(0).toUpperCase();

  return (
    <div style={{ fontFamily: FONT, background: WHITE, color: TEXT, width: "100%", maxWidth: 390, borderRadius: 12, overflow: "hidden", border: "1px solid #DADCE0" }}>
      {/* Status bar */}
      <div style={{ height: 20, background: WHITE, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 14px", fontSize: 11, fontWeight: 600 }}>
        <span>{new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</span>
        <span style={{ letterSpacing: 1, fontSize: 10 }}>••• 5G 100</span>
      </div>

      {/* Mail app top bar */}
      <div style={{ height: 48, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 12px", borderBottom: "1px solid #ECECEC" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1.5 14a2 2 0 01-2 1.8H8.5a2 2 0 01-2-1.8L5 6" /><path d="M10 11v6M14 11v6" /></svg>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M3 6h13l5 6-5 6H3" /></svg>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M22 4L12 14.01l-3-3" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></svg>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><circle cx="12" cy="6" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="12" cy="18" r="1.5" /></svg>
        </div>
      </div>

      {/* Subject row */}
      <div style={{ padding: "16px 16px 8px" }}>
        <div style={{ fontSize: 19, fontWeight: 500, color: TEXT, lineHeight: 1.3, letterSpacing: -0.2 }}>{subject}</div>
        <div style={{ display: "inline-block", marginTop: 8, fontSize: 11, fontWeight: 500, color: "#3C4043", border: "1px solid #DADCE0", borderRadius: 4, padding: "1px 6px" }}>Inbox</div>
      </div>

      {/* From/To row */}
      <div style={{ display: "flex", alignItems: "flex-start", padding: "8px 16px 12px", gap: 12, borderBottom: "1px solid #F1F3F4" }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", flexShrink: 0, background: "#1A73E8", color: WHITE, fontSize: 14, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {initial}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
            <span style={{ fontWeight: 600, color: TEXT }}>{fromName}</span>
            <span style={{ color: TEXT3, fontSize: 12 }}>&lt;{fromEmail}&gt;</span>
          </div>
          <div style={{ fontSize: 12, color: TEXT3, marginTop: 2 }}>
            to {toEmail}
            <span style={{ marginLeft: 4, fontSize: 10 }}>▾</span>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6, color: TEXT3 }}>
          <span style={{ fontSize: 11 }}>{sentDate}</span>
          <div style={{ display: "flex", gap: 12 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M9 17l-5-5 5-5" /><path d="M20 18v-2a4 4 0 00-4-4H4" /></svg>
          </div>
        </div>
      </div>

      {/* Email body — hero asset */}
      {assetUrl && (
        <div style={{ width: "100%", aspectRatio: "16 / 9", background: "#F1F5F9", overflow: "hidden" }}>
          <img src={assetUrl} alt="email hero" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}

      {/* Body copy */}
      <div style={{ padding: "20px 18px 4px", fontSize: 14, lineHeight: 1.6, color: "#202124", whiteSpace: "pre-wrap" }}>
        {preheader && (
          <div style={{ fontSize: 12, color: TEXT3, marginBottom: 16 }}>{preheader}</div>
        )}
        {body || (
          <>
            <p style={{ marginBottom: 12 }}>Hi there,</p>
            <p style={{ marginBottom: 12 }}>We're thrilled to have you with us. As a thank-you, here's an exclusive offer to get you started — explore the new collection and find something you'll love.</p>
            <p style={{ marginBottom: 12 }}>Tap the button below to start shopping.</p>
          </>
        )}
      </div>

      {/* CTA */}
      <div style={{ padding: "8px 18px 20px" }}>
        <a href={ctaUrl} target="_blank" rel="noreferrer" style={{ display: "inline-block", textDecoration: "none", height: 42, lineHeight: "42px", padding: "0 22px", borderRadius: 6, background: ctaColor, color: WHITE, fontSize: 13, fontWeight: 600, letterSpacing: 0.2 }}>
          {ctaText}
        </a>
      </div>

      {/* Email footer */}
      <div style={{ padding: "12px 18px 16px", borderTop: "1px solid #F1F3F4", fontSize: 11, color: TEXT3, lineHeight: 1.5 }}>
        <div>You're receiving this because you signed up at {fromEmail.split("@")[1]}.</div>
        <div style={{ marginTop: 4 }}>
          {/* Preview-only chrome — links are inert by design (this is a
              mockup of the recipient's email client, not a live email). */}
          <span style={{ color: "#1A73E8", cursor: "default" }}>Unsubscribe</span>
          <span style={{ margin: "0 6px" }}>·</span>
          <span style={{ color: "#1A73E8", cursor: "default" }}>View in browser</span>
        </div>
      </div>

      {/* Mail action bar */}
      <div style={{ height: 52, borderTop: "1px solid #ECECEC", display: "flex", justifyContent: "space-around", alignItems: "center", background: WHITE }}>
        {[
          <svg key="reply" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A73E8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="9 17 4 12 9 7" /><path d="M20 18v-2a4 4 0 00-4-4H4" /></svg>,
          <svg key="reply-all" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="7 17 2 12 7 7" /><polyline points="12 17 7 12 12 7" /><path d="M22 18v-2a4 4 0 00-4-4H7" /></svg>,
          <svg key="forward" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="15 17 20 12 15 7" /><path d="M4 18v-2a4 4 0 014-4h12" /></svg>,
          <svg key="archive" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5F6368" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" /></svg>,
        ].map((icon, i) => (
          <div key={i} style={{ width: 44, height: 44, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: i === 0 ? "rgba(26,115,232,0.1)" : "transparent" }}>
            {icon}
          </div>
        ))}
      </div>
    </div>
  );
}
